var Color = require("color")

const styles = theme => {
  var color = Color(theme.palette.primary.main)
  const isLight = color.isLight()

  return {
    actionBarWidth: {
      maxWidth: "98%",
      minHeight: 65,
      paddingLeft: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        paddingLeft: theme.spacing(2)
      }
    },
    BulkActionsButton: {
      backgroundColor: theme.palette.warning.light,
      width: 160,
      height: 36,
      margin: "auto",
      fontSize: 14,
      fontWeight: 400,
      color: "#000",
      textAlign: "center",
      fontFamily: "Roboto",
      borderRadius: 2,
      marginLeft: theme.spacing(3),
      "&:hover": {
        backgroundColor: theme.palette.warning.light
      },
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(2)
      }
    },
    sortName: {},
    sortsContainer: {
      [theme.breakpoints.down("sm")]: {
        display: "none"
      },
      "& $sortName": {
        color: isLight ? theme.palette.text.primary : "#fff"
      }
    },
    filterContainer: {
      width: "200px",
      paddingLeft: theme.spacing(6)
    },
    icon: {
      position: "absolute",
      left: theme.spacing(2)
    }
    // sortIcon: {
    //   color: theme.palette.primary.light
    // },
    // sortName: {
    //   color: theme.palette.secondary.light
    // }
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/ActionBar/styles.js